<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title {{ title }}
              | &nbsp
              a.button.is-dark.is-rounded(@click="backPage")
                i.fas.fa-times
            br
        .columns
          .column.is-4
            ToggleButton(
              v-model="searchAll" 
              :labels="{checked: 'Pendientes', unchecked: 'Fecha'}"
              :color="{checked: '#53565A', unchecked: '#C8102E'}"
              :width="configButton.width"
              :height="configButton.height"
              :font-size="configButton.fontSize"
              )
          .column.is-2
            .field
              input#chCons.is-checkradio.is-black(type='checkbox' v-model='verCons')
              label.is-size-6(for='chCons') 
                span.icon.is-dark
                  i.fas.fa-eye
                | &nbspCons.
          .column(:class="permisos.inventarios!=6 ? 'is-4' : 'is-4 is-offset-1'")
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por serie | resguarda | ubicación | Oficina | Descripcion',
                  v-model="query_articulos",
                )
          .column.is-3
            a.button.is-black(v-show="permisos.inventarios!=6" @click="irSalidas('s')")
              i.fas.fa-plus
              | &nbsp Nuevo Traspaso
        .columns(v-show="result_query != ''")
          .column.is-offset-8.is-4
            span.tag.is-black.is-small {{ result_query }}
        .columns(v-show="!searchAll")
          .column.is-2
            label.label Fecha de Traspasos:
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fecha'
                  :config="config"
                  class="input"
                )
        TbTraspasosArt(v-show="!verCons" :articulos="articulosFilter" @firmar="firmarSalida" @imprimir="imprimirSalida")
        TbTraspasosCons(v-show="verCons" :consumibles="consumiblesFilter" @imprimir="imprimirSalidaConsumible" @firmarConsumible="firmarSalidaConsumible")
        .columns.column-blanco
</template>

<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import InventarioServices from '../../services/inventario/inventario'
import TbTraspasosArt from './Tb_TraspasosArt.vue'
import TbTraspasosCons from './Tb_TraspasosCons.vue'
import flatPickr from 'vue-flatpickr-component'
import { ToggleButton } from 'vue-js-toggle-button'
import 'flatpickr/dist/flatpickr.css'
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default {
  name: 'Traspasos',
  components: { Loader, NavBarInventario, flatPickr, TbTraspasosArt, TbTraspasosCons, ToggleButton },
  data () {
    return {
      isLoading: true,
      traspasos: [],
      traspasosShow: [],
      traspasosCons: [],
      traspasosConsShow: [],
      traspasos_Pend: [],
      traspasosShow_Pend: [],
      traspasosCons_Pend: [],
      traspasosConsShow_Pend: [],
      query_articulos: '',
      articulos: [],
      consumibles: [],
      articulosFilter: [],
      consumiblesFilter: [],
      query: 'ALL',
      result_query: '',
      fecha: moment().format('YYYY-MM-DD'),
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'Y-m-d',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: Spanish, // locale for this instance only          
      },
      title: '',
      verCons: false,
      almacenes: [],
      origen: {},
      searchAll: true,
        configButton: {
          width: 110,
          height: 30,
          fontSize: 14,
        }
    }
  },
  watch: {
    fecha() {
      this.obtenerTraspasos()
      this.obtenerTraspasosConsumibles()
    },

    searchAll() {
      this.searchAll ? this.configButton.width = 110 : this.configButton.width = 80
      if (this.searchAll) {
        this.articulosFilter = this.traspasosShow_Pend
        this.consumiblesFilter = this.traspasosConsShow_Pend
      } else {
        this.articulosFilter = this.traspasosShow
        this.consumiblesFilter = this.traspasosConsShow
      }
    },

    query_articulos() {
      if (this.query_articulos.length < 1) {
        return
      }

      const QUERY = this.query_articulos.toUpperCase()
      if (this.searchAll) {
        const articulosFiltrados = this.traspasos_Pend.filter( art => { 
          return `${art.serie} ${art.recibe} ${art.oficina} ${art.descripcion}`.toUpperCase().includes(QUERY)
        })
        this.articulosFilter =  articulosFiltrados

        const consumiblesFiltrados = this.traspasosCons_Pend.filter( art => { 
          return `${art.serie} ${art.recibe} ${art.oficina} ${art.descripcion}`.toUpperCase().includes(QUERY)
        })
        this.consumiblesFilter =  consumiblesFiltrados
      } else {
        const articulosFiltrados = this.traspasos.filter( art => { 
          return `${art.serie} ${art.recibe} ${art.oficina} ${art.descripcion}`.toUpperCase().includes(QUERY)
        })
        this.articulosFilter =  articulosFiltrados

        const consumiblesFiltrados = this.traspasosCons.filter( art => { 
          return `${art.serie} ${art.recibe} ${art.oficina} ${art.descripcion}`.toUpperCase().includes(QUERY)
        })
        this.consumiblesFilter =  consumiblesFiltrados
      }
    },
  },
  methods: {
    iniciarComponente() {
      this.obtenerAlmacenes()
    },

    obtenerTraspasos() {
      let ubi = ''
      switch (this.almacenSelect) {
        case  '':
          ubi = 'ALL'
          break
        case  'c':
          ubi = this.origen.clave
          break
        case  'g':
          ubi = this.origen.clave
          break
        default:
          ubi = this.origen.clave
          break
      }
      InventarioServices.getTraspasos(this.fecha, ubi)
        .then( data => {
          this.isLoading = false
          this.traspasos = data.map(this.convertirTraspasos)
          this.traspasosShow = this.traspasos
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirTraspasos(trasp) {
      return {
        ...trasp,
        id: parseInt(trasp.id),
        i_entrega: parseInt(trasp.i_entrega),
        i_traslada: parseInt(trasp.i_traslada),
        i_recibe: parseInt(trasp.i_recibe),
        id_estado: parseInt(trasp.id_estado),
      }
    },

    obtenerTraspasosConsumibles () {
      let ubi = ''
      switch (this.almacenSelect) {
        case  '':
          ubi = 'ALL'
          break
        case  'c':
          ubi = this.origen.id_oficina
          break
        case  'g':
          ubi = this.origen.id_oficina
          break
        default:
          ubi = this.origen.id_oficina
          break
      }
      InventarioServices.getTraspasosCons(this.fecha, ubi)
        .then( data => {
          this.isLoading = false
          this.traspasosCons = data.map(this.convetirTraspasosCons)
          this.traspasosConsShow = this.traspasosCons
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
        })
    },

    convetirTraspasosCons (salida) {
      return {
        ...salida, 
        id: parseInt(salida.id),
        cantidad_b: parseInt(salida.cantidad_b),
        cantidad_e: parseInt(salida.cantidad_e),
        cantidad_r: parseInt(salida.cantidad_r),
        cantidad_t: parseInt(salida.cantidad_t),
        cantidad_u: parseInt(salida.cantidad_u),
        id_destino: parseInt(salida.id_destino),
        estadoRec: parseInt(salida.estadoRec),
        id_estado: parseInt(salida.id_estado),
        id_salida: parseInt(salida.id_salida),
        idconsumible: parseInt(salida.idconsumible),
        id_origen: parseInt(salida.id_origen),
      }
    },

    displayToast(tema,text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: tema, 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },

    backPage() {
      this.$router.back()
    },

    irSalidas(tipo) {
      this.$store.commit('selectSalida', tipo)
      this.$router.push( {path: '/Inventario/Busqueda'})
    },

    obtenerAlmacenes () {
        InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirAlmacenes (ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        id_oficina: parseInt(ofi.id_oficina),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },

    obtenerAlmacenOrigen() {
      const $origenOfi = this.almacenes.find( ofi => ofi.clave === this.almacenSelect)
      if (!$origenOfi) {
        this.almacenes.map( alm => {
          const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
          if (encontrado) {
            this.origen = alm
          }
        })
      } else {
        this.origen = $origenOfi
      }
      this.obtenerTraspasosPendientes()
    },

    firmarSalida(obj) {
      if (this.permisos.inventarios == 6) {
        return
      }
      const { data, estado } = obj
      let myObj = {}
      switch (estado) {
        case 1:
          if (this.userLogin.id === data.id_entrega) {
            console.log('Pasa a firma del Usuario')
            myObj = {
              id_salida: data.id_salida,
              fechaReg: data.fechaReg,
              id_entrega: data.id_entrega,
              entrega: data.entrega,
              id_traslada: data.id_traslada,
              traslada: data.traslada,
              id_recibe: data.id_recibe,
              recibe: data.recibe,
              id_autoriza: data.id_autoriza,
              autoriza: data.autoriza,
              origen: data.origen,
              destino: data.destino,
              area: data.area,
              estado: estado,
              hash: data.h,
              firma_entrega: data.firma_entrega,
              firma_traslada: data.firma_traslada,
              firma_recibe: data.firma_recibe
            }
            this.irFirmarSalida(myObj)
          } else {
            console.log('')
            this.displayToast('No es el usuario que entrega.', 'ban', 'Ok')
          }
          break
        case 2:
          myObj = {
            num: data.num,
            id_salida: data.id_salida,
            fechaReg: data.fechaReg,
            id_entrega: data.id_entrega,
            entrega: data.entrega,
            id_traslada: data.id_traslada,
            traslada: data.traslada,
            id_recibe: data.id_recibe,
            recibe: data.recibe,
            id_autoriza: data.id_autoriza,
            autoriza: data.autoriza,
            origen: data.origen,
            destino: data.destino,
            area: data.area,
            estado: estado,
            hash: data.h,
            firma_entrega: data.firma_entrega,
            firma_traslada: data.firma_traslada,
            firma_recibe: data.firma_recibe
          }
          this.irFirmarSalida(myObj)
          break
        case 3:
          myObj = {
            num: data.num,
            id_salida: data.id_salida,
            fechaReg: data.fechaReg,
            id_entrega: data.id_entrega,
            entrega: data.entrega,
            id_traslada: data.id_traslada,
            traslada: data.traslada,
            id_recibe: data.id_recibe,
            recibe: data.recibe,
            id_autoriza: data.id_autoriza,
            autoriza: data.autoriza,
            origen: data.origen,
            destino: data.destino,
            area: data.area,
            estado: estado,
            hash: data.h,
            firma_entrega: data.firma_entrega,
            firma_traslada: data.firma_traslada,
            firma_recibe: data.firma_recibe
          }
          this.irFirmarSalida(myObj)
          break
      }
    },

    firmarSalidaConsumible(obj) {
      if (this.permisos.inventarios == 6) {
        return
      }
      const { data, estado } = obj
      let myObj = {}
      switch (estado) {
        case 1:
          if (this.userLogin.id === data.id_entrega) {
            console.log('Pasa a firma del Usuario')
            myObj = {
              id_salida: data.id_salida,
              fechaReg: data.fechaReg,
              id_entrega: data.id_entrega,
              entrega: data.entrega,
              id_traslada: data.id_traslada,
              traslada: data.traslada,
              id_recibe: data.id_recibe,
              recibe: data.recibe,
              id_autoriza: data.id_autoriza,
              autoriza: data.autoriza,
              origen: data.origen,
              ubicacion: {
                nombre: data.destino
              },
              area: data.area,
              estado: estado,
              hash: data.h,
              firma_entrega: data.firma_entrega,
              firma_traslada: data.firma_traslada,
              firma_recibe: data.firma_recibe,
              isSalida: true,
            }
            this.irFirmarConsumible(myObj)
          } else {
            console.log('')
            this.displayToast('No es el usuario que entrega.', 'ban', 'Ok')
          }
          break
        case 2:
          myObj = {
            num: data.num,
            id_salida: data.id_salida,
            fechaReg: data.fechaReg,
            id_entrega: data.id_entrega,
            entrega: data.entrega,
            id_traslada: data.id_traslada,
            traslada: data.traslada,
            id_recibe: data.id_recibe,
            recibe: data.recibe,
            id_autoriza: data.id_autoriza,
            autoriza: data.autoriza,
            origen: data.origen,
            ubicacion: {
              nombre: data.destino
            },
            area: data.area,
            estado: estado,
            hash: data.h,
            firma_entrega: data.firma_entrega,
            firma_traslada: data.firma_traslada,
            firma_recibe: data.firma_recibe,
            isSalida: true,
          }
          this.irFirmarConsumible(myObj)
          break
        case 3:
          myObj = {
            num: data.num,
            id_salida: data.id_salida,
            fechaReg: data.fechaReg,
            id_entrega: data.id_entrega,
            entrega: data.entrega,
            id_traslada: data.id_traslada,
            traslada: data.traslada,
            id_recibe: data.id_recibe,
            recibe: data.recibe,
            id_autoriza: data.id_autoriza,
            autoriza: data.autoriza,
            origen: data.origen,
            ubicacion: {
              nombre: data.destino
            },
            area: data.area,
            estado: estado,
            hash: data.h,
            firma_entrega: data.firma_entrega,
            firma_traslada: data.firma_traslada,
            firma_recibe: data.firma_recibe,
            isSalida: true,
          }
          this.irFirmarConsumible(myObj)
          break
      }
    },

    irFirmarSalida(salida) {
      this.isLoading = false
      this.$store.commit('firmarSalida', salida)
      this.$router.push('/Inventario/Salida/Firma')
    },

    irFirmarConsumible(salida) {
      this.isLoading = false
      this.$store.commit('firmarSalidaConsumible', salida)
      this.$router.push('/Inventario/Consumibles/Firmar')
    },
    
    imprimirSalida(data) {
      const currentUrl = window.location.hostname
      const almacen = this.almacenes.find( a => a.clave === data.ofi_origen)
      const idAlm = almacen ? almacen.id_oficina : 0
      const link = `https://${currentUrl}/servidores/reportes/inventarios/salidaI.php?id=${data.id_salida}&alm=${idAlm}`
      if (!open(link)) {
        console.log('Error')
      }
    },

    imprimirSalidaConsumible(data) {
      const currentUrl = window.location.hostname
      const link = `https://${currentUrl}/servidores/reportes/inventarios/salidaCons_I.php?id=${data.id_salida}&alm=${data.id_origen}`
      if (!open(link)) {
        console.log('Error')
      }
    },

    obtenerTraspasosPendientes() {
      let ubi = ''
      switch (this.almacenSelect) {
        case  '':
          ubi = this.origen.clave
          break
        case  'c':
          ubi = this.origen.clave
          break
        case  'g':
          ubi = this.origen.clave
          break
        default:
          ubi = this.origen.clave
          break
      }
      InventarioServices.getTraspasosPendientes(ubi)
        .then( data => {
          this.isLoading = false
          this.traspasos_Pend = data.map(this.convertirTraspasos)
          this.traspasosShow_Pend = this.traspasos_Pend
          this.articulos = this.traspasosShow_Pend
          this.articulosFilter = this.articulos
          this.obtenerTraspasosConsumiblesPendientes()
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
        })
    },

    obtenerTraspasosConsumiblesPendientes() {
      let ubi = ''
      switch (this.almacenSelect) {
        case  '':
          ubi = this.origen.clave
          break
        case  'c':
          ubi = this.origen.id_oficina
          break
        case  'g':
          ubi = this.origen.id_oficina
          break
        default:
          ubi = this.origen.id_oficina
          break
      }
      InventarioServices.getTraspasosConsPendientes(ubi)
        .then( data => {
          this.isLoading = false
          this.traspasosCons_Pend = data.map(this.convetirTraspasosCons)
          this.traspasosConsShow_Pend = this.traspasosCons_Pend
          this.consumibles = this.traspasosConsShow_Pend
          this.consumiblesFilter = this.consumibles
          this.obtenerTraspasos()
          this.obtenerTraspasosConsumibles()
        })
        .catch( e => {
          this.isLoading = false
          this.displayToast('bubble',`Error: ${e.message}`,'ban', 'OK')
        })
      
    },
  },
  computed: {
    ...mapState(['userLogin', 'areaAsignacion', 'almacenSelect', 'permisos'])
  },
  created () {
    switch (this.almacenSelect) {
      case 'TPA-ALS':
        this.title = 'Traspasos TPA GIA'
        break
      case 'EB04-ALG':
        this.title = 'Traspasos EB04 GIA'
        break
      case 'CORP-ALG':
        this.title = 'Traspasos CORP GIA'
        break
      case 'IRGE-ALM':
        this.title = 'Traspasos IRGE'
        break
      case 'CORP-ALM':
        this.title = 'Traspasos CORP'
        break
      case 'TPA-ALM':
        this.title = 'Traspasos TPA'
        break
      case 'EB04-ALM':
        this.title = 'Traspasos EB04'
        break
      case 'EB00-ALM':
        this.title = 'Traspasos EB00'
        break
      case 'EB01-ALM':
        this.title = 'Traspasos EB01'
        break
      case 'EB02-ALM':
        this.title = 'Traspasos EB02'
        break
      case 'EB03-ALM':
        this.title = 'Traspasos EB03'
        break
      case 'ERM-ALM':
        this.title = 'Traspasos ERM'
        break
      default:
        this.title = 'Traspasos'
        break
    }
    this.iniciarComponente()
  },
  mounted() {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.modalStatus = false // how to hide any open modal?
        this.modalStatusD = false
      }
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/Traspasos.vue